import { useAuth } from '@egw/auth'
import { Headers } from '@egw/components'
import { configClient } from '@egw/config'
import { WEALTH_ROUTES } from '@egw/constants'
import { SignInPage as SignIn } from '@egw/features-auth'
import { useTranslation } from '@egw/i18n'
import { Layout } from '@egw/layouts'
import { type FC } from 'react'
import { Navigate, useSearchParams } from 'react-router'

export const SignInPage: FC = () => {
  const { t } = useTranslation()
  const config = configClient.getConfig() as { env: string }
  const { isAuthenticated } = useAuth()
  const [searchParams] = useSearchParams()
  const redirectUrl = searchParams.get('redirect')

  if (config.env === 'demo-dev' || config.env === 'demo-prod') {
    return <Navigate to={WEALTH_ROUTES.HOME.path} />
  }

  if (isAuthenticated) {
    return <Navigate to={redirectUrl ?? WEALTH_ROUTES.OVERVIEW.path} />
  }

  return (
    <Layout>
      <Headers title={t('pages.sign-in.title')} />
      <SignIn />
    </Layout>
  )
}
